import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="full-page-wrapper" style={{ 
      background: 'linear-gradient(to left bottom, #777777, #1a1a1a)', 
      minHeight: '100vh', 
      height: '100vh',
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'flex-start', 
      alignItems: 'center', 
      paddingTop: '0px',
      width: '100%'
    }}>
      <div className="app-theme" style={{ 
        padding: 'var(--spacing-lg, 30px)', 
        width: '100%', 
        maxWidth: '800px',
        position: 'relative',
        top: 0,
        left: 0
      }}>
        <div className="about-us" style={{
          position: 'relative',
          top: 0,
          left: 0
        }}>
          <h1>About Bagpipe Blasphemy</h1>
          
          <section className="about-us__section">
            <h2>Our Mission</h2>
            <p>
              Bagpipe Blasphemy is an innovative platform designed to enhance the worldwide community of Highland Bagpipers. 
              Our goal is to make piping more accessible, engaging, and fun. We strive to employ technology to facilitate traditional piping instruction and to offer a platform to experiment with new ideas.
            </p>
          </section>

          <section className="about-us__section">
            <h2>Development Status</h2>
            <p>
              This platform is actively under development, and we're constantly adding new features 
              and improvements. We are driven to experiment so features are guaranteed to change. As we grow, we're committed to creating the best possible 
              experience for pipers of all skill levels.
            </p>
          </section>

          <section className="about-us__section">
            <h2>Your Feedback Matters</h2>
            <p>
              We welcome all feedback and suggestions! Your input helps shape the future of Bagpipe 
              Blasphemy. Whether you've found a bug, have a feature request, or just want to share 
              your thoughts, we want to hear from you.
            </p>
            <p>
              Please use our Contact form to get in touch with us. We review all feedback and take 
              your suggestions seriously as we continue to develop and improve the platform.
            </p>
          </section>

          <section className="about-us__section">
            <h2>Get Involved</h2>
            <p>
              Join our growing community of pipers! You can:
            </p>
            <ul className="about-us__list">
              <li>Try out our interactive learning tools</li>
              <li>Provide feedback through the Contact form</li>
              <li>Request new features you'd like to see</li>
              <li>Share your experience with other pipers!</li>
            </ul>
          </section>

          <section className="about-us__section">
            <h2>Intellectual Property</h2>
            <p>
              All source code is copyright 2025 Bagpipe Blasphemy.
            </p>
            <p>
            Unless otherwise specified, all content is copyright 2025 Bagpipe Blasphemy.
            </p>
            <p style={{ marginTop: '16px' }}>
              Open source credits are listed on our <a href="/credits">Credits</a> page. Thank you to all who contribute to these projects!
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default AboutUs; 